import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { FindProductComponent } from '../../../component/find-product/find-product.component';
import { AlertController, LoadingController, ModalController, NavController, ToastController } from '@ionic/angular';
import { UtilService } from '../../../service/util.service';
import { UserProfile } from '../../../models/user-profile.model';
import { MutasiAntarCounterService } from '../mutasi-antar-counter.service';
import { PosService } from '../../pos/pos.service';
import { Storage } from '@ionic/storage';
import { UserData } from '../../../providers/user-data';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleAccess } from '../../../models/role-access.model';
import { environment } from '../../../../environments/environment';
import * as utf8 from 'crypto-js/enc-utf8';
import AES = require('crypto-js/aes');
import { FindStockComponent } from '../../../component/find-stock/find-stock.component';

@Component({
  selector: 'app-mutasi-antar-counter-form',
  templateUrl: './mutasi-antar-counter-form.page.html',
  styleUrls: ['./mutasi-antar-counter-form.page.scss'],
})
export class MutasiAntarCounterFormPage implements OnInit {
  form: FormGroup;
  productList: any[]=[];
  counterList:any[] = [];
  activeCounterList:any[] = [];
  filteredCounterList:any[]=[];
  token:any='';
  filteredProduct:any[] = [];
  userProfile: UserProfile = new UserProfile();
  productGimmickList:any[];
  mstProductListSearch:any[] = [];
  mstBarcodeList:any[] = [];
  mstProductList:any[] = [];
  userAccess: any[] = [];
  roleName: any;
  roleAccess = new RoleAccess();
  counterSelected:boolean=false;
  branchId :number=0;
  mutasiId:any;
  action:any;
  searchBy:any=0;
  warehouseType:any=0;
  showCounterByProduct:boolean=false;
  showProductList:boolean=false;
  requestStatus:any='open';
  headerId:number=0;
  cancelReason:any='';
  requestRevisionReason:any='';
  rejectReason:any='';
  stockData:any[]=[];
  isSubmitting:boolean=false;
  isActiveOriginCounter:boolean=false;
  requestNote:any='';
  sendNote:any='';
  receiveNote:any='';
  reviseNote:any='';
  
  history:any[]=[];
  sendIsValid=true;
  requestNumber:any='';
  isProcessing = false;
  canSendRequest =false;
  canSendItem =false;
  canReceive=false;
  isInitializing = true;

  constructor(private fb:FormBuilder,
    private modalController:ModalController,
    private utilService:UtilService,
    private mutasiAntarCounterService:MutasiAntarCounterService,
    private toastCtrl : ToastController,
    private posService: PosService,
    private storage: Storage,
    private navCtrl:NavController,
    private userData: UserData,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private alertController:AlertController,
    private loadingController:LoadingController
  ) {

    this.form = this.fb.group({
      id:[0],
      counter_origin: [],
      counter_destination: [],
      counter_name:[],
      request_note: [''],
      send_note: [''],
      receive_note: [''],
      revise_note:[''],
      search_by:['0'],
      warehouse_type:['R'],
      product: this.fb.array([])
    });
    this.addProduct();
  }
  isQtyValid(): boolean {
    const items = this.product.controls;

    for (let i = 0; i < items.length; i++) {
      const qtyControl = items[i].get('qty_request');
      const stockControl = items[i].get('stock');

      if (!qtyControl ) {
        return false;
      }
      if(this.searchBy=='C' && !stockControl){
        return false;
      }
      const qty = parseInt(qtyControl.value || '0', 10);
      const stock = parseInt(stockControl.value || '0', 10);
      if(qty<1){
        return false;
      }
      if(this.searchBy=='C'){
        if (qty > stock) {
          return false;
        }
      }
    }

    return true;
  }

  ngOnInit() {
    this.form = this.fb.group({
      id:[0],
      counter_origin: [null, Validators.required],
      product: this.fb.array([]),
      counter_destination: [null],
      counter_name:[null],
      search_by:['0'],
      request_note: [''],
      send_note: [''],
      warehouse_type:['R'],
      receive_note: [''],
      revise_note:[''],
    });
  }
  ionViewDidEnter() {
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.userAccess = access;
        this.roleName = this.userProfile.role_detail ? this.userProfile.role_detail.role_name : null;
        this.roleAccess = this.userData.checkAccess(this.router.url, this.userAccess, this.userProfile);
        if(!this.roleAccess){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          this.navCtrl.navigateForward(['/']);
        }
        else{
          this.form = this.fb.group({
            id:[0],
            counter_origin: [null, Validators.required],
            product: this.fb.array([]),
            counter_destination: [null],
            counter_name:[null],
            search_by:['0'],
            request_note: [''],
            send_note: [''],
            warehouse_type:['R'],
            receive_note: [''],
            revise_note:['']
          });
          this.isSubmitting = false;
          this.history = [];
          this.getActiveCounters();
        }
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }

  getActiveCounters(){
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let options = {
        "token": this.token,
        "counter_id": this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list,
      };
      this.mutasiAntarCounterService.getForMutationForm(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        this.counterList = response.results.counter_data;
        this.activeCounterList = response.results.active_counter_data;
        this.getData();
      }, (err) => {
        this.utilService.loadingDismiss();
      });
    });
  }

  getData() {
    this.sendIsValid=true;
    this.requestNumber = '';
    this.requestNote = '';
    this.counterSelected = false;
    this.isActiveOriginCounter =false;
    this.canSendRequest =false;
    this.canSendItem =false;
    this.canReceive=false;
    this.activeRoute.queryParams.subscribe((snapshot) => {
      let myKey=environment.myKey;
      this.action = JSON.parse(
        AES.decrypt(snapshot.a, myKey).toString(utf8)
      );
      this.mutasiId = AES.decrypt(snapshot.i, myKey).toString(utf8);
      if(this.action!='A'){
        let option={
          "token": this.token,
          "username":this.userProfile.username
        };
        this.mutasiAntarCounterService.getMutationById(this.mutasiId,option)
        .subscribe((response: any) => {
          let data = response.results.data;
          let detail = response.results.detail;
          let data_stock = response.results.stock;
          let warehouse_type = data!=null ? data.warehouse_type : '';
          let counter_destination = data!=null ? parseInt(data.counter_id_destination) : 0;
          let counter_origin = data!=null ?parseInt(data.counter_id_origin):0;
          let search_by = data!=null ?data.search_by:0;
          this.requestStatus =  data!=null ?data.request_status:'open';
          this.headerId = data!=null ? data.id:0;
          this.requestNumber =  data!=null ?data.request_number:'';
          this.searchBy =search_by;
          this.requestNote =  data!=null ?data.request_note:'';
          this.receiveNote =  data!=null ?data.receive_note:'';
          this.sendNote =  data!=null ?data.send_note:'';
          this.reviseNote = data != null ? data.reviseNote : '';

          // Cek apakah counter_id_origin ada di list
          if (this.userProfile.counter_id_list.includes((counter_origin))) {
            this.canSendItem = true;
          }
          if (this.userProfile.counter_id_list.includes((counter_destination))) {
            this.canSendRequest = true;
            this.canReceive = true;
          }

          this.history= response.results.history;
          
          if(this.activeCounterList.find(x=>x.id==counter_origin)){
            this.isActiveOriginCounter =true;
          }
          if(counter_origin!=0){
            this.counterSelected = true;
          }
          const selectedCounterTujuan = this.counterList.find(x => x.id == counter_destination);
          let selectedBranchId = 0;
          if(selectedCounterTujuan){
            selectedBranchId = selectedCounterTujuan.branch_id;
            this.branchId = parseInt(selectedCounterTujuan.branch_id);
          }
          this.filteredCounterList = this.activeCounterList.filter(x=>x.branch_id==selectedBranchId);
          const selectedCounter = this.filteredCounterList.find(x => x.id == counter_origin);
          this.form.patchValue({
            counter_origin: selectedCounter,
            counter_destination: selectedCounterTujuan,
            search_by:search_by,
            request_note: this.requestNote,
            revise_note:this.reviseNote,
            send_note: this.sendNote,
            receive_note: this.receiveNote,
            warehouse_type:warehouse_type
          });
          // setelah semua selesai
          this.isInitializing = false;
          this.product.clear();
          this.changeSearchBy(counter_origin);

          detail.forEach(p => {
            let getStock = data_stock.find(x=>x.product_id==p.product_id);
            let stock = 0;
            if(getStock){
              stock  = getStock.stock_month;
            }
            this.product.push(
              this.fb.group({
                id: p.id,
                stock:stock,
                product_id:p.product_id,
                product_name:p.product_name,
                qty_request: p.qty_request,
                qty_send: p.qty_send,
                qty_receipt: p.qty_receipt,
                request_note: p.request_note,
                send_note: p.send_note,
                receive_note: p.receive_note
              })
            );
          });
          this.getMstProduct();
        });
      }
      if(this.action=='V'){
        let counterControl = this.form.get('counter_destination');
        counterControl.disable();
        let counterOriginControl = this.form.get('counter_origin');
        counterOriginControl.disable();
        let search_by = this.form.get('search_by');
        search_by.disable();
      }
      if(this.action=='A'){
        this.isInitializing = false;
      }
      if(this.action!='A'){
        let counterControl = this.form.get('counter_destination');
        counterControl.disable();
      }
    });
  }
  get product(): FormArray {
    return this.form.get('product') as FormArray;
  }

  addProduct() {
    this.isSubmitting = false;
    if(this.searchProduct && this.searchBy=='P'){
      this.form.get('counter_origin').setValue(null);
    }
    const group = this.fb.group({
      id:[0],
      stock:[0],
      product_id: [],
      product_name:[],
      qty_request:[],
      qty_send: [],
      qty_receipt: [],
      request_note: [''],
      send_note: [''],
      receive_note: [''],
      revise_note: ['']
    });
    this.product.push(group);
    this.filteredProduct.push(this.productList);
  }

  searchProduct(ev:any, index:number) {
    const val = ev.target.value.toLowerCase();
    this.filteredProduct[index] = this.productList.filter(p =>
      p.name.toLowerCase().includes(val)
    );
  }
  async findProduct(index: any) {
    const modal = await this.modalController.create({
      component: FindProductComponent,
      componentProps: {
        productList: this.productList,
      },
      backdropDismiss: false,
    });

    modal.onDidDismiss().then((modelData) => {
      const data = modelData.data;
      if (data) {
        const productArray = this.product;
        const newProductId = data.id;
        const exists = productArray.controls.some(ctrl => ctrl.get('product_id').value === newProductId);
        if (!exists) {
          let getStock = this.stockData.find(x=>x.product_id==newProductId);
          let stock = 0;
          if(getStock){
            stock  = getStock.stock_month;
          }
          productArray.at(index).patchValue({
            product_name: data.product_name,
            product_id: newProductId,
            stock: stock
          });
        } else {
          alert('Product ini sudah dipilih sebelumnya!');
        }
      }
    });
    return await modal.present();
  }
  async findStock() {
    this.isSubmitting = false;
    let product = this.form.value.product.map(p => ({
        "product_id": p.product_id,
        "product_name": p.product_name,
        "qty": p.qty_request
      }));
      
    const formValues = this.form.getRawValue(); // ambil termasuk disabled
    let originId =0;
    if(this.searchBy=='C'){
      const origin = formValues.counter_origin;
      originId = origin.id !== undefined ? origin.id : 0;
    }
    let warehouseTypeId=0;
    if(formValues.warehouse_type=='P'){
      warehouseTypeId = 2;
    }
    else if(formValues.warehouse_type=='R'){
      warehouseTypeId = 1;
    }
    const modal = await this.modalController.create({
      component: FindStockComponent,
      componentProps: {
        token:this.token,
        counterIdOrigin:originId,
        branchId: this.branchId,
        productList: product,
        warehouseType:warehouseTypeId
      },
      backdropDismiss: false,
    });
    modal.onDidDismiss().then((modelData) => {
      const data = parseInt(modelData.data);
      if(data!=0){
        if(this.searchBy=='P'){
          const selectedCounterOrigin = this.activeCounterList.find(x => x.id == data);
          this.showCounterByProduct = true;
          this.form.patchValue({
            counter_origin: selectedCounterOrigin
          });
        }
      }
    });
    return await modal.present();
  }

  async alertMsg(msg:any) {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: msg,
      buttons: [
        {
          text: 'OK',
          handler: () => {
          }
        }
      ]
    });
    await alert.present();
  }
  
  removeProduct(index: number) {
    if (this.product && this.product.length > index) {
      this.product.removeAt(index);
    }
  }
  removeAllProduct() {
    while (this.product.length !== 0) {
      this.product.removeAt(0);
    }
  }
  async getMstProduct() {
    if(this.form.getRawValue().counter_destination){
      this.productList = [];
      const today = new Date();
      const dayOnly = today.toISOString().split('T')[0];
      let options = {
        "counter_id": this.form.getRawValue().counter_destination ? this.form.getRawValue().counter_destination.id : 0,
        "token": this.token,
        "trans_date":dayOnly
      };
      this.posService.getProduct(options).subscribe((response) => {
        if (response.status.code == 200) {
          this.mstProductListSearch = [];
          this.mstBarcodeList = [];
          this.mstProductList = [];
          this.productGimmickList =[];
          for (let i = 0; i < response.results.length; i++) {
            if(response.results[i].is_virtual_bundling!='1'){
                this.productList.push({
                  id: String(response.results[i].id),
                  product_id: String(response.results[i].id),
                  barcode: response.results[i].barcode,
                  product_name: response.results[i].product_name,
                  initial_name: response.results[i].initial_name,
                  price: response.results[i].price,
                });
            }
          }
          if(response.result_gimmick.length>0){
            for (let i = 0; i < response.result_gimmick.length; i++) {
              this.productList.push({
                id: String(response.result_gimmick[i].id),
                product_id: String(response.result_gimmick[i].id),
                barcode: response.result_gimmick[i].barcode,
                product_name: response.result_gimmick[i].product_name,
                initial_name: response.result_gimmick[i].initial_name,
                price: response.result_gimmick[i].price,
              });
            }
          }
        }
        this.getStock();
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal mendapatkan data Product! Silahkan refresh!' }).then(t => t.present());
      });
    }
  }
  
  selectDestinationCounter() {
    let selectedBranchId = 0;
    this.counterSelected = false;
    this.removeAllProduct();
    this.branchId = 0;
    this.stockData=[];
    this.form.get('counter_origin').setValue(null);
    this.isSubmitting = false;
    if(this.form.value.counter_destination.id!=0){
      this.counterSelected=true;
    }
    let findCounter = this.activeCounterList.find(x=>x.id==this.form.value.counter_destination.id);
    if(findCounter){
      selectedBranchId = findCounter.branch_id;
      this.branchId = parseInt(findCounter.branch_id);
    }
    this.filteredCounterList = this.activeCounterList.filter(x=>x.branch_id==selectedBranchId && x.id!=this.form.value.counter_destination.id);
    this.getMstProduct();
  }
  async selectOriginCounter() {
    this.removeAllProduct();
    this.isSubmitting = false;
    if(this.form.value.counter_origin.id!=0){
      this.showProductList=true;
    }
    if(this.searchBy=='C'){
      await this.getStock();
    }
  }
  getStock(): Promise<any> {
    const formValues = this.form.getRawValue();
let originId = 0;
if (formValues.counter_origin && formValues.counter_origin.id) {
  originId = formValues.counter_origin.id;
}
    let warehouseTypeId = 0;
    if (formValues.warehouse_type == 'P') {
      warehouseTypeId = 2;
    } else if (formValues.warehouse_type == 'R') {
      warehouseTypeId = 1;
    }

    return this.utilService.loadingPresent('Harap tunggu...')
      .then(() => {
        let options = {
          token: this.token,
          branch_id: this.branchId,
          product_list: this.productList,
          counter_id_origin: originId,
          warehouse_type_id: warehouseTypeId
        };

        return new Promise((resolve, reject) => {
          this.mutasiAntarCounterService.getStockForMutation(options).subscribe({
            next: (response) => {
              this.stockData = response.results.data;
              this.utilService.loadingDismiss();
              resolve(this.stockData);
            },
            error: (err) => {
              this.utilService.loadingDismiss();
              reject(err);
            }
          });
        });
      });
  }

  async submitForm() {
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach(key => {
        const control = this.form.get(key);
        if (control && control.invalid) {      
          this.alertMsg(key +" harus diisi");
        }
      });
      return;
    }
    const formValues = this.form.getRawValue(); // ambil termasuk disabled
    const origin = formValues.counter_origin;
    const destination = formValues.counter_destination;
    if (origin && destination) {
      const originId = origin.id !== undefined ? origin.id : origin;
      const tujuanId = destination.id !== undefined ? destination.id : destination;
      if (originId == tujuanId) {
        this.alertMsg("Counter asal dan Counter tujuan tidak boleh sama");
        return;
      }
    }
    else if(!destination){
      this.alertMsg("Counter tujuan belum dipilih");
      return;
    }
    else if(!origin){
      this.alertMsg("Counter asal belum dipilih");
      return;
    }
    if(this.form.value.search_by=='0'){
      this.alertMsg("Search By harus dipilih");
      return;
    } 
    if(this.form.value.product.length==0){
      this.alertMsg("Product harus dipilih");
      return;
    }
    
    const options = {
      "token": this.token,
      "id":this.headerId,
      "branch_id":this.branchId,
      "counter_origin": formValues.counter_origin.id,
      "counter_destination": formValues.counter_destination.id,
      "request_note": this.form.value.request_note,
      "send_note": this.form.value.send_note,
      "receive_note": this.form.value.receive_note,
      "revise_note": this.form.value.revise_note,
      "search_by": this.form.value.search_by,
      "warehouse_type":this.form.value.warehouse_type,
      "product": this.form.value.product.map(p => ({
        "product_id": p.product_id,
        "product_name": p.product_name,
        "qty_request": p.qty_request,
        "request_note": p.request_note,
        "send_note": p.send_note,
        "receive_note": p.receive_note
      })),
      "created_by":this.userProfile.username,
      "request_status":"open"
    };

    try {
      this.mutasiAntarCounterService.submitForm(options).subscribe((response) => {
        this.form.reset();
        this.removeAllProduct();
        this.showConfirmInput();
      });
    } catch (error) {
      console.error('Gagal kirim:', error);
    }
  }

  allProductSelected(): boolean {
    const productArray = this.form.get('product') as FormArray;
    if(productArray.controls.length==0){
      return false;
    }
    for (let i = 0; i < productArray.controls.length; i++) {
      const ctrl = productArray.controls[i] as FormGroup;
      const productIdCtrl = ctrl.get('product_id');
      const productNameCtrl = ctrl.get('product_name');
      const productQtyCtrl = ctrl.get('qty_request');
      if (!productIdCtrl || !productIdCtrl.value) {
        return false;
      }
      if (!productNameCtrl || !productNameCtrl.value) {
        return false;
      }
      if (!productQtyCtrl || !productQtyCtrl.value) {
        return false;
      }
    }
    return true;
  }
  changeSearchBy(counter_origin:any){
    this.isSubmitting = false;
    const formValues = this.form.getRawValue();
    this.searchBy = formValues.search_by;
    let counterControl = this.form.get('counter_origin');
    this.showCounterByProduct = false;
    this.showProductList = false;
    if(this.searchBy=='0'){
    }
    else if(this.searchBy=='P'){
      counterControl.disable();
      this.showProductList = true;
      this.showCounterByProduct = true;
    }
    else if(this.searchBy=='C'){
      if(counter_origin=='0'){
        this.form.get('counter_origin').setValue(null);
      }
      counterControl.enable();
      this.showProductList= true;
      if(counter_origin=='0'){
        this.showProductList = false;
        this.removeAllProduct();
      }
    }
    if(this.searchBy!='C' && this.headerId!=0){
      this.showProductList=true;
    }
  }
  
  async changeWarehouseType(){

  if (this.isInitializing) return;
    this.isSubmitting = false;
    const formValues = this.form.getRawValue();
    this.warehouseType = formValues.warehouse_type;
    let counterControl = this.form.get('counter_origin');
    this.showCounterByProduct = false;
    
    if(this.searchBy=='P'){
      counterControl.disable();
      this.showCounterByProduct = true;
      this.form.get('counter_origin').setValue(null);
    }
    else if(this.searchBy=='C'){
      await this.getStock(); 
      console.log(this.stockData);
      let productArray = this.form.get('product') as FormArray; 
      productArray.controls.forEach((control, i) => { 
        let value = control.value; if (!value || !value.product_id) return; 
        let getStock = this.stockData.find( x => x.product_id == value.product_id ); 
        control.patchValue({ 
          stock: getStock ? Number(getStock.stock_month) : 10
        }); this.validateQty(i); 
      });
    }
  }

async updateStatus(status: any) {
  if (this.isProcessing) return; // prevent double click
  this.isProcessing = true;

  // tampilkan loader cantik
  const loading = await this.loadingController.create({
    message: 'Sedang memproses...',
    spinner: 'circles', // bisa juga 'dots', 'crescent', 'bubbles'
    translucent: true
  });
  await loading.present();
  try {
    if (status=='delivery' && (this.requestStatus == 'sent' || this.requestStatus == 'revise')) {
      const productArray = this.form.get('product') as FormArray;
      productArray.controls.forEach((control, i) => {
        const value = control.value;
        if (!value || !value.product_id) return;
        this.validateQtySend(i);
      });
    }
    else if (status=='received' && this.requestStatus == 'delivery') {
      const productArray = this.form.get('product') as FormArray;
      productArray.controls.forEach((control, i) => {
        const value = control.value;
        if (!value || !value.product_id) return;
        this.validateQtyReceipt(i);
      });
    }
    else if(status=='reject' || status=='revise'){
      this.sendIsValid=true;
    }

    if (this.sendIsValid) {
      const formValues = this.form.getRawValue();
      const send_note = formValues.send_note;
      const receive_note = formValues.receive_note;
      const revise_note = formValues.revise_note;

      const options = {
        token: this.token,
        id: this.headerId,
        send_note,
        receive_note,
        revise_note,
        product: this.form.value.product.map(p => ({
          id: p.id,
          qty_send: p.qty_send,
          qty_receipt: p.qty_receipt,
          send_note: p.send_note,
          receive_note: p.receive_note
        })),
        updated_by: this.userProfile.username,
        request_status: status,
        cancel_reason: this.cancelReason,
        request_revision_reason: this.requestRevisionReason,
        reject_reason: this.rejectReason
      };

      await this.mutasiAntarCounterService.updateStatus(options).toPromise();

      await loading.dismiss(); // hide loader
      this.showConfirmInput();
    } else {
      await loading.dismiss(); // hide loader
      this.scrollToProduct();
    }
  } catch (err) {
    await loading.dismiss(); // hide loader
    console.error('Gagal kirim:', err);

    let message = 'Terjadi kesalahan';
    if (err && err.error && err.error.message) {
      message = err.error.message;
    }

    this.alertMsg(message);
  } finally {
    this.isProcessing = false; // enable button lagi
  }
}
  scrollToProduct() {
    const el = document.getElementById('productSection');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
   async showConfirmInput() {
    const alert = await this.alertController.create({
      header: "Notification",
      cssClass: "custom-alert-class",
      message: "Data sudah tersimpan!",
      buttons: [
        {
          text: "OK",
          handler: () => {
            this.navCtrl.navigateForward(["/mutasi-antar-counter"]);
          },
        },
      ],
    });
    await alert.present();
  }
  async cancelConfirmation(action:any) {
    let actionName = 'membatalkan';
    if(action=='reject'){
      actionName= 'menolak';
    }
    else if(action=='revise'){
      actionName='meminta revisi';
    }
    const alert = await this.alertController.create({
      header: 'Confirmation',
      cssClass:'custom-alert-class',
      message: 'Apakah anda yakin untuk '+actionName+' mutasi ini?',
      buttons: [
        {
          text: 'Tidak',
          handler: () => {}
        },
        {
          text: 'Ya',
          handler: () => {
            this.showCancelReason(action);
          }
        }
      ]
    });
    await alert.present();
  }
   async showCancelReason(action:any) {
    let actionName = 'membatalkan';
    if(action=='reject'){
      actionName= 'menolak';
    }
    else if(action=='revise'){
      actionName='meminta revisi';
    }
    const alert = await this.alertController.create({
      header: 'Confirmation',
      subHeader: '',
      message: 'Silahkan masukkan alasan '+actionName,
      inputs: [
        {
          name: 'cancelReason',
          placeholder: 'Alasan',
          type: 'text'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: () => {}
        },
        {
          text: 'OK',
          handler: (input: any) => {
            if(!input.cancelReason){
              this.alertMsg("Alasan "+actionName+" harus diisi");
            }
            else if(input.cancelReason.length < 4){
              this.alertMsg("Alasan "+actionName+" minimal 5 karakter");
            }
            else{
              let nextStatus = '';
              this.cancelReason ='';
              this.rejectReason = '';
              this.requestRevisionReason ='';
              if(action=='reject'){
                this.rejectReason = input.cancelReason ? input.cancelReason : '-';
                nextStatus= 'reject';
              }
              else if(action=='cancel'){
                this.cancelReason = input.cancelReason ? input.cancelReason : '-';
                nextStatus= 'canceled';
              }
              else if(action=='revise'){
                this.requestRevisionReason = input.cancelReason ? input.cancelReason : '-';
                nextStatus='revise';
              }
              this.updateStatus(nextStatus)
            }
          }
        }
      ]
    });
    await alert.present();
  }
  validateQty(index: number) {
    if(this.searchBy=='C'){
      const group = this.product.at(index);
      const qtyControl = group.get('qty_request');
      const stockControl = group.get('stock');
      if (!qtyControl || !stockControl) {
        return;
      }
      const qty = qtyControl.value;
      const stock = stockControl.value;
      if(parseInt(qty)<1){
        qtyControl.setErrors({ invalidQty: true });
      }
      else{
        if (qty > stock) {
          qtyControl.setErrors({ exceedStock: true });
        } else {
          qtyControl.setErrors(null);
        }
      }
    }
    else if(this.searchBy=='P'){
     this.form.patchValue({
            counter_origin: null
      });
    }
  }
  validateQtySend(index: number) {
    if(this.requestStatus=='sent'){
      const group = this.product.at(index);
      const qtyRequestControl = group.get('qty_request');
      const qtyControl = group.get('qty_send');
      const stockControl = group.get('stock');
      if (!qtyControl || !stockControl) {
        return;
      }
      const qty = qtyControl.value;
      const qtyRequest = qtyRequestControl.value;
      const stock = stockControl.value;
      if(qty!=qtyRequest){
        qtyControl.setErrors({ notMatch: true });
      }
      else if(parseInt(qty)<1){
        qtyControl.setErrors({ invalidQty: true });
      }
      else{
        if (qty > stock) {
          qtyControl.setErrors({ exceedStock: true });
        } else {
          qtyControl.setErrors(null);
        }
      }
      this.checkAllValid('qty_send');
    }
    else if(this.requestStatus=='revise'){
      const group = this.product.at(index);
      const qtyRequestControl = group.get('qty_request');
      const qtyControl = group.get('qty_send');
      if (!qtyControl) {
        return;
      }
      const qty = qtyControl.value;
      const qtyRequest = qtyRequestControl.value;
      if(qty!=qtyRequest){
        qtyControl.setErrors({ notMatch: true });
      }
      else if(parseInt(qty)<1){
        qtyControl.setErrors({ invalidQty: true });
      }
      else{
        qtyControl.setErrors(null);
      }
      this.checkAllValid('qty_send');
    }
  }
  validateQtyReceipt(index: number) {
    if(this.requestStatus=='delivery'){
      const group = this.product.at(index);
      const qtyReceiptControl = group.get('qty_receipt');
      const qtySend = group.get('qty_send');
      if (!qtySend || !qtyReceiptControl) {
        return;
      }
      const qty = qtySend.value;
      const qtyReceipt = qtyReceiptControl.value;
      if(qty!=qtyReceipt){
        qtyReceiptControl.setErrors({ notMatch: true });
      }
      else if(parseInt(qty)<1){
        qtyReceiptControl.setErrors({ invalidQty: true });
      }
      else{
        qtyReceiptControl.setErrors(null);
      }
      this.checkAllValid('qty_receipt');
    }
  }
  checkAllValid(qtyType:any) {
    this.sendIsValid = true;
    this.product.controls.forEach((group: any) => {
      const qtyControl = group.get(qtyType);
      if (qtyControl && qtyControl.invalid) {
        this.sendIsValid = false;
      }
    });
  }
}